import { SET_REGISTRATION } from '../constant';

export const swRegistrationAction = registration => {
	return {
		registration,
		type: SET_REGISTRATION,
	};
};
